import "./Loader.css";

const Loader = () => {
  return <div className="loading">Loading...</div>;
};

export default Loader;
